$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  if (p === 'organizer_product_extra' && a === 'list') {
    $('select[name=extra_product_id]').select2({
      theme: 'bootstrap4',
    });

    $('select[name=product_extra_template_id]').select2({
      theme: 'bootstrap4',
    });
  }
});
